const Form = {
  ON_FORM_SENT: 'form/sent',
}

export default Form;
